import { Navigate, createFileRoute } from '@tanstack/react-router';

import { useNetworkFeatures } from '../features/auth/useNetworkFeatures';
import { useShigoPermissions } from '../features/auth/useShigoPermissions';
import { resolveAvailablePublisherDetailsTabs } from '../features/supply/publishers/publisherDetailsAccess';

export const Route = createFileRoute('/supply/publishers_/$publisherId/details/')({
  component: PublisherDetailsIndexRoute,
});

function PublisherDetailsIndexRoute() {
  const { publisherId } = Route.useParams();
  const { permissions } = useShigoPermissions();
  const { features } = useNetworkFeatures();
  const firstTab = resolveAvailablePublisherDetailsTabs(permissions, features)[0];

  if (!firstTab) {
    return <Navigate to="/supply/publishers" search={{}} replace />;
  }
  return (
    <Navigate
      to={`/supply/publishers/$publisherId/details/${firstTab}`}
      params={{ publisherId }}
      search={{}}
      replace
    />
  );
}
